var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopiarFuncaoQtlink = function SvgCopiarFuncaoQtlink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36639 0.5C8.52311 0.5 8.67341 0.562256 8.78422 0.673073C8.89504 0.78389 8.9573 0.93419 8.9573 1.09091C8.9573 1.24763 8.89504 1.39793 8.78422 1.50874C8.67341 1.61956 8.52311 1.68182 8.36639 1.68182H1.86639V9.36364C1.86639 9.52036 1.80413 9.67066 1.69332 9.78147C1.5825 9.89229 1.4322 9.95455 1.27548 9.95455C1.11876 9.95455 0.96846 9.89229 0.857644 9.78147C0.746827 9.67066 0.68457 9.52036 0.68457 9.36364V1.68182C0.68457 1.03182 1.21639 0.5 1.86639 0.5H8.36639Z",
    fill: "#004379"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23016 2.86353H10.7302C11.0436 2.86353 11.3442 2.98804 11.5658 3.20967C11.7875 3.43131 11.912 3.73191 11.912 4.04534V12.3181C11.912 12.6315 11.7875 12.9321 11.5658 13.1537C11.3442 13.3754 11.0436 13.4999 10.7302 13.4999H4.23016C3.91672 13.4999 3.61612 13.3754 3.39449 13.1537C3.17285 12.9321 3.04834 12.6315 3.04834 12.3181V4.04534C3.04834 3.73191 3.17285 3.43131 3.39449 3.20967C3.61612 2.98804 3.91672 2.86353 4.23016 2.86353Z",
    fill: "#004379"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopiarFuncaoQtlink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copiar_funcao_qtlink.2c8a9757.svg";
export { ForwardRef as ReactComponent };